<script setup lang="ts">
interface Props {
  canNight: boolean
  canEmpty: boolean
  canDeck: boolean
}

const props = defineProps<Props>()

const isNight = defineModel<boolean>('isNight', {
  required: true,
})

const isEmpty = defineModel<boolean>('isEmpty', {
  required: true,
})

const hasDeck = defineModel<boolean>('hasDeck', {
  required: true,
})

function setEmpty(empty: boolean) {
  if (empty)
    isNight.value = false
  isEmpty.value = empty
}

function setNight(night: boolean) {
  if (night)
    isEmpty.value = false
  isNight.value = night
}

function setDeck(deck: boolean) {
  hasDeck.value = deck
}
</script>

<template>
  <div class="flex gap-2">
    <button
      :disabled="!props.canNight"

      class="h-16 w-16 flex items-center justify-center rounded-full transition-all"
      :class="{
        'opacity-50': !props.canNight,
        'bg-white text-black': isNight,
        'bg-black text-white': !isNight,
      }"
      @click="setNight(!isNight)"
    >
      <IconConfiguratorMoon class="w-10" />
    </button>
    <button
      :disabled="!props.canEmpty"
      class="h-16 w-16 flex items-center justify-center rounded-full transition-all"
      :class="{
        'opacity-50': !canEmpty,
        'bg-white text-black': !isEmpty,
        'bg-black text-white': isEmpty,
      }"

      @click="setEmpty(!isEmpty)"
    >
      <IconWater class="w-10" />
    </button>
    <button
      :disabled="!props.canDeck"
      class="h-16 w-16 flex items-center justify-center rounded-full p-1 transition-all"
      :class="{
        'opacity-50': !canDeck,
        'bg-white text-black': hasDeck,
        'bg-black text-white': !hasDeck,
      }"

      @click="setDeck(!hasDeck)"
    >
      <IconRoll class="w-8" />
    </button>
  </div>
</template>
